<template>
  <div id="base" class="" v-title title="首页">

    <!-- Unnamed (图片) -->
    <div id="u51" class="ax_default image">
      <img id="u51_img" class="img " src="@/images/shenqin/u51.png"/>
    </div>

    <!-- Unnamed (图片) -->
    <div id="u52" class="ax_default image">
      <img id="u52_img" class="img " src="@/images/shenqin/u52.png"/>
    </div>

    <!-- Unnamed (矩形) -->
    <div id="u53" class="ax_default box_1">
      <div id="u53_div" class=""></div>
    </div>
    <div class="success-page">
        <h1 >机构自评分成功！</h1>

        <div class="account-info">
            <ul>
                <li><strong>机构名称：</strong> {{ orgName }}</li>
                <li><strong>自评总分：</strong> {{ selfScoreTotal }}分</li>
<!--                <li><strong>自评星级：</strong> {{ starLevel }}</li>-->
            </ul>
        </div>
        <p  class="tips" >请您耐心等待审核...</p>
        <div class="buttons2" size="mini" @click="goIndex">返回首页</div>
    </div>

    <!-- Unnamed (矩形) -->
    <div id="u58" class="ax_default label">
      <div id="u58_div" class=""></div>
      <div id="u58_text" class="text ">
        <p style="text-align:center;"><span>河北省体育局版权所有 主办：河北省体育局 </span></p>
        <p style="text-align:center;"><span>地址：河北省石家庄市中山东路372号 邮编：050011 邮箱：hebeitiyuju@163.com </span></p>
        <p style="text-align:center;"><span>网站运维电话：0311-85266259 冀ICP备：2022017224号 冀公网安备：13010202002305号 </span></p>
      </div>
    </div>


  </div>
</template>

<script>

export default {
  name: 'BaoBei',
  data() {
    return {
        orgName: '',  // 机构名称
        selfScoreTotal: '',  // 自评总分
        //starLevel:''//星级
    }
  },
  created() {
      this.orgName = localStorage.getItem('orgName');
      this.selfScoreTotal = localStorage.getItem('selfScoreTotal');
      //let selfStarLevel = localStorage.getItem('starLevel')
      //this.starLevel = selfStarLevel == '3' ? '三星' :(selfStarLevel == '4' ? '四星' :(selfStarLevel == '5' ? '五星' : '低于三星'))
  },
  methods: {
      goIndex(){
          this.$router.push('/')
      },
  }
}
</script>
<style scoped>

#base {
  position: absolute;
  z-index: 0;
}

#u51_img {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 1000px;
  height: 227px;
}

#u51 {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 1000px;
  height: 227px;
}


#u52_img {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 342px;
  height: 76px;
}

#u52 {
  border-width: 0px;
  position: absolute;
  left: 32px;
  top: 62px;
  width: 342px;
  height: 76px;
}


#u53_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 1000px;
  height: 710px;
  background: inherit;
  background-color: rgba(242, 242, 242, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

#u53 {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 227px;
  width: 1000px;
  height: 710px;
}
.success-page {
  /*  text-align: center;
    padding: 20px;*/
    border-width: 0px;
    position: absolute;
    left: 390px;
    top: 260px;
    width: 342px;
    height: 76px;
}

.account-info {
    margin-top: 70px;
}

.account-info ul {
    list-style: none;
    padding: 0;
    margin-left: 23px;
}

.account-info li {
    margin-bottom: 5px;
}

.tips{
    margin-left: 23px;
    color: red;
}

.buttons2 {
    margin-top: 50px;
    cursor: pointer;
    position: relative;
    left: 6%;
    width: 190px;
    height: 45px;
    background: inherit;
    background-color: rgba(255, 51, 51, 1);
    border: none;
    border-radius: 3px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FFFFFF;
    text-align: center;
    line-height: 45px;
}

#u58_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 559px;
  height: 80px;
  background: inherit;
  background-color: rgba(255, 255, 255, 0);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  line-height: 20px;
}

#u58 {
  border-width: 0px;
  position: absolute;
  left: 194px;
  top: 792px;
  width: 559px;
  height: 80px;
  line-height: 20px;
}

#u58_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: -30px;
  width: 559px;
  white-space: nowrap;
}


</style>
